var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.091,
    height: 123.615,
    viewBox: "0 0 155.091 123.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_360",
    "data-name": 360,
    d: "M124.688,49.671v-26.4a2.081,2.081,0,0,0-1.454-2.141L79.615,2.1a2.7,2.7,0,0,0-1.939,0L34.057,21.13A2.285,2.285,0,0,0,32.6,23.271v26.4C12.489,56.806,1.1,67.984,1.1,80.352c0,20.454,31.018,36.627,71.729,38.054l-3.15,3.092a2.27,2.27,0,0,0,0,3.33,2.373,2.373,0,0,0,3.393,0l7.27-7.135a2.27,2.27,0,0,0,0-3.33l-7.27-7.135a2.373,2.373,0,0,0-3.393,0,2.27,2.27,0,0,0,0,3.33l2.908,2.854C35.753,112.222,5.947,97.476,5.947,80.352c0-9.751,9.936-19.265,26.656-25.686V80.352a2.081,2.081,0,0,0,1.454,2.141l43.619,19.027a2.094,2.094,0,0,0,1.939,0l43.619-19.027a2.285,2.285,0,0,0,1.454-2.141V54.9c16.721,6.422,26.656,15.7,26.656,25.686,0,15.7-24.475,29.492-58.4,32.584a2.411,2.411,0,0,0-2.181,2.616,2.374,2.374,0,0,0,2.423,2.141h.242c37.076-3.33,62.763-18.789,62.763-37.34C156.191,67.984,144.559,57.044,124.688,49.671ZM78.645,6.86l37.561,16.411L78.645,39.682,41.084,23.271Zm-41.2,20.216L76.222,43.963V95.811L37.449,78.925V27.076ZM81.069,95.811V43.963l38.773-16.886V78.925Z",
    transform: "translate(-1.1 -1.926)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3D);
export default __webpack_public_path__ + "static/media/Icon_3D.fed605efa7665298a8fa46d95e7a72f8.svg";
export { ForwardRef as ReactComponent };